import "./onenews.scss";
import { inject, observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { baseUrl } from "stores/main";

const OneNews = ({
  img,
  header,
  description,
  date,
  token,
  preview,
  id,
  setSignInModal
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (token) {
      navigate(`./${id}`);
    } else setSignInModal(true);
  };
  return (
    <div className="onenews" onClick={handleClick}>
      <div className="onenews__img-container">
        {img !== -1 ? (
          <img src={`${baseUrl}${img}`} className="onenews__img" alt="" />
        ) : (
          <div className="onenews__img-empty"></div>
        )}
      </div>
      <div className="onenews__rows">
        <p className="onenews__rows-header">{header}</p>
        <p className="onenews__rows-text">
          {preview ? (
            <>{preview.substring(0, 200)}...</>
          ) : (
            <>{description.substring(0, 200)}...</>
          )}
        </p>
        <div className="onenews__cols">
          <p className="onenews__cols-date">{moment(date).format("L")}</p>
          <p className="onenews__cols-link">Подробнее</p>
        </div>
      </div>
    </div>
  );
};

export default inject(({ usersStore, modalWindows }) => {
  const { setSignInModal } = modalWindows;
  const { token } = usersStore;
  return {
    token,
    setSignInModal
  };
})(observer(OneNews));
